import React from "react"
import Container from "../Container"
import { Props } from "./props"
import "../../../styles/full_height"

const CrowdLamp: React.FC<Props> = (props) => (
  <Container contentType="lamp" {...props} />
)
export default CrowdLamp
